import { getCookie, setCookie } from './cookies';

const COOKIE_SUBSCRIPTIONS = 'subscriptions';

export const getCookieSubscriptions = () => getCookie(COOKIE_SUBSCRIPTIONS);

export const setCookieSubscriptions = () => setCookie(COOKIE_SUBSCRIPTIONS, new Date().toUTCString(), 30);
